// public/js/features/devices/api.js
// Optional tenant narrows the list server-side (TenantIndex GSI; 'unassigned'
// = ownerless devices, platform roles only). See docs/tenant-scope.md.
export async function loadDevices(tenant = null) {
  const url = tenant ? `api/v1/devices?tenant=${encodeURIComponent(tenant)}` : 'api/v1/devices';
  const res = await window.authenticatedFetch(url);
  if (!res.ok) throw new Error('Failed to load devices');
  const data = await res.json();
  return data.devices || [];
}

export async function assignDevice(deviceId, assetId) {
  const res = await window.authenticatedFetch(`api/v1/devices/${encodeURIComponent(deviceId)}/assign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ assetId })
  });
  if (!res.ok) throw new Error('Assign failed');
  return res.json();
}

export async function deleteDevice(deviceId) {
  const res = await window.authenticatedFetch(`api/v1/devices/${encodeURIComponent(deviceId)}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Delete failed');
  return res.json();
}

// Grant ownership of one or many devices to a tenant (platform roles only).
export async function grantDevices(deviceIds, tenantId) {
  const res = await window.authenticatedFetch('api/v1/admin/devices/grant', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ deviceIds, tenantId }),
  });
  if (!res.ok) {
    let msg = 'Grant failed';
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  return res.json();
}